export default __webpack_public_path__ + "static/media/kelvin_yuan.67142677.jpg";